import React, { useRef } from 'react';

import './style.scss';
import Media from '../Media/Media';
import Text from '../Text/Text';
import Heading from '../Heading/Heading';
import Button from '../Button/Button';
import SingleSelect from '../Singleselect/SingleSelect';

const NormalSlide = (props) => {
  const {
    data,
    flashcard_id: flashcardId,
    user_response: userResponse,
    slideIndex,
    nextSlide,
    syncSlides,
  } = props;
  const normalSlideRef = useRef(null);

  return (
    <div
      id={`normal-slide-container-${slideIndex}`}
      ref={normalSlideRef}
      className='normal-slide-container'
      style={{
        backgroundColor: data.backgroundColor,
        backgroundImage:
          data.backgroundImageUrl === undefined
            ? ''
            : `url(${data.backgroundImageUrl})`,
        backgroundPosition:
          data.backgroundImageUrl === undefined ? '' : 'center',
        backgroundSize: data.backgroundImageUrl === undefined ? '' : 'cover',
      }}
    >
      <div
        className='slide-data-container'
        id={`slide-data-container-${slideIndex}`}
      >
        {data.slideData.map((componentData, index) =>
          componentData.type === 'heading-1' ? (
            <Heading {...componentData} key={index} />
          ) : componentData.type === 'heading-2' ? (
            <Heading {...componentData} key={index} />
          ) : componentData.type === 'text' ? (
            <Text {...componentData} key={index} />
          ) : componentData.type === 'image' ||
            componentData.type === 'video' ||
            componentData.type === 'gif' ? (
            <Media {...componentData} key={index} />
          ) : componentData.type === 'button' ? (
            <Button
              {...{
                ...componentData,
                slideIndex,
                nextSlide,
              }}
              key={index}
            />
          ) : componentData.type === 'single-select' ? (
            <SingleSelect
              {...{
                ...componentData,
                slideIndex,
                nextSlide,
                syncSlides,
                flashcardId,
                userResponse,
              }}
              key={index}
            />
          ) : (
            <></>
          )
        )}
        <div id={`button-fixed-extra-div-${slideIndex}`} />
      </div>
    </div>
  );
};

export default NormalSlide;
